import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../FinancialPlansSoonToExperieAndExpired.module.scss';
import useTable from '../../../../hooks/useTable';

type Props = {
  onChangeData: (any) => any;
  labelFilterDefault?: string;
  disabledFilter?: boolean;
  dataTabs?: any;
  fnDataButtonsFilter: (any) => any;
  selectLabel: string;
  fnSelectLabel: (string) => void;
};

export const SelectFilterData = ({
  onChangeData,
  dataTabs,
  fnDataButtonsFilter,
  selectLabel,
  fnSelectLabel,
}: Props) => {
  const { projects } = useTable();
  const { t } = useTranslation();

  const options = [
    {
      value: 3,
      optionLabel: 'all',
    },
    {
      value: 0,
      optionLabel: 'new_within_the_deadline',
      icon: 'green',
    },
    {
      value: 1,
      optionLabel: 'new_due_in_the_next_30_days',
    },
    {
      value: 2,
      optionLabel: 'expired',
    },
  ];

  const onChangeDataFilter = e => {
    const option = Number(e.target.value);

    if (option === 2) {
      onChangeData(projects?.filter(item => item?.field7 === 'RED'));
      fnSelectLabel('2');
    } else if (option === 1) {
      onChangeData(projects?.filter(item => item?.field7 === 'YELLOW'));
      fnSelectLabel('1');
    } else if (option === 0) {
      onChangeData(projects?.filter(item => item?.field7 === 'GREEN'));
      fnSelectLabel('0');
    } else {
      onChangeData(projects);
      fnSelectLabel('3');
    }

    if (option !== 3) {
      if (dataTabs.find(item => item.id === option).selected) {
        const changeState = dataTabs.map(obj => {
          return { ...obj, selected: false };
        });
        fnDataButtonsFilter(changeState);
      } else {
        const changeState = dataTabs.map(obj => {
          if (obj.id === option) {
            return { ...obj, selected: true };
          }
          return { ...obj, selected: false };
        });
        fnDataButtonsFilter(changeState);
      }
    } else {
      const changeState = dataTabs.map(obj => {
        return { ...obj, selected: false };
      });
      fnDataButtonsFilter(changeState);
    }
  };

  return (
    <div className={styles['select-filter-container']}>
      <span className={styles['select-filter-data-text']}>{t('content_manager_delegations_filters')}: </span>
      <select value={selectLabel} className={styles['select-css']} onChange={e => onChangeDataFilter(e)}>
        {options &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {t(option.optionLabel)}
            </option>
          ))}
      </select>
    </div>
  );
};
